<template>
  <div class="area-page">
    <div class="header-wrap app-flex-mid-center">
      <img src="../../../assets/area/bg-1.png" class="bg" />
    </div>
    <div class="main">
      <base-title title="工业产品" rich-title="industrial product"></base-title>
      <div class="desc-cont first" @click="operation(1)">
        <div class="left-box app-flex-mid-center">
          <div class="text">
            我司经营范围包含：美国寿力螺杆式空压机、离心式空压机、螺杆式真空泵；西梅卡变压吸附制氮机和制氧机、氮气净化系统、气体增压系统；纽曼泰克全系列吸干机、冷干机及管道过滤器；成高阀门、美国泰科阀门、日本中北阀门（NAKAKITA）、德国西门子、美国费希尔等品牌阀门以及普瑞奇、德国贺德克、德国科德宝、美国唐纳森、美国颇尔等品牌的过滤芯。
            <br />在兼具质量的同时为客户提供最优的价格、最佳的服务与售后。
          </div>
        </div>
        <div class="right-box">
          <div class="image-wrap app-flex-mid-center">
            <img src="../../../assets/area/1.png" alt="" class="desc-icon" />
          </div>
        </div>
      </div>

      <base-title title="自控系统研发" rich-title="system"></base-title>
      <div class="desc-cont" @click="operation(2)">
        <div class="left-box">
          <div class="image-wrap app-flex-mid-center">
            <img src="../../../assets/area/2.png" alt="" class="desc-icon" />
          </div>
        </div>
        <div class="right-box app-flex-mid-center">
          <div class="text">
            自控系统以解决实际的用户痛点为目标，通过统一管控，使设备的启用采用最优配置，通过优化和算法对生产环境下的变数进行最大能力的控制，达到实现无忧生产与运营的最终目的。
          </div>
        </div>
      </div>

      <base-title title="智能视觉" rich-title="Intelligent vision"></base-title>
      <div class="desc-cont" @click="operation(3)">
        <div class="left-box app-flex-mid-center">
          <div class="text">
            智能视觉IntelligentVision（ivision）是一款即开即用的AI计算服务。使用智能视觉可以让零算法基础的开发者和企业快速享受到AI视觉计算能力带来的便利，智能视觉面向存储在线上环境的图片、视频文件提供包括图像分类、物体检测、事件检测、物体识别等能力，可应用于家庭监控、明厨亮灶、智慧工地等各种场景，通过API支撑各类场景应用的开发。
          </div>
        </div>
        <div class="right-box">
          <div class="image-wrap app-flex-mid-center">
            <img src="../../../assets/area/3.png" alt="" class="desc-icon" />
          </div>
        </div>
      </div>

      <base-title title="教育信息化" rich-title="Educational informatization"></base-title>
      <div class="desc-cont" @click="operation(4)">
        <div class="left-box">
          <div class="image-wrap app-flex-mid-center">
            <img src="../../../assets/area/4.png" alt="" class="desc-icon" />
          </div>
        </div>
        <div class="right-box app-flex-mid-center">
          <div class="text">
            教育信息化的核心内容就是要使教学手段科技化、教育传播信息化、教学方式现代化。在教育过程中较全面地运用以计算机、多媒体、大数据、人工智能和网络通讯为基础的现代信息技术，促进教育改革，从而适应正在到来的信息化社会提出的新要求，对深化教育改革，实施素质教育，具有重大的意义。
          </div>
        </div>
      </div>
    </div>

    <base-foot></base-foot>
  </div>
</template>

<script>
import BaseTitle from '../components/BaseTitle.vue'
import BaseFoot from '../components/BaseFoot.vue'
import { mapActions } from 'vuex'

export default {
  name: 'AreaPage',
  components: {
    BaseTitle,
    BaseFoot
  },
  data() {
    return {}
  },
  methods: {
    ...mapActions(['navigateTo']),
    operation(idx) {
      let child
      const parent = { id: 1, name: '业务领域', url: '/area' }
      switch (idx) {
        case 1:
          child = { id: 5, name: '工业产品', url: '/area/pro' }
          break
        case 2:
          child = { id: 6, name: '自控系统研发', url: '/area/dev' }
          break
        case 3:
          child = { id: 7, name: '智能视觉', url: '/area/vis' }
          break
        case 4:
          child = { id: 8, name: '教育信息化', url: '/area/edu' }
          break
      }

      this.navigateTo({ $router: this.$router, parent, child })
    }
  }
}
</script>

<style lang="scss" scoped>
.area-page {
  width: 100%;
  .header-wrap {
    width: inherit;
    height: 676px;
    overflow: hidden;
    .bg {
      height: 676px;
      width: auto;
    }
  }

  .main {
    padding: 0px 260px 330px;
    .desc-cont {
      display: flex;
      background-color: #e2edf6;
      margin-top: 70px;
      color: #63676a;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        transform: scale(1.01);
        box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.2);
      }
      &:not(.first) .text {
        padding: 0px 70px;
      }
      .image-wrap {
        height: 670px;
        width: 930px;
        overflow: hidden;
        .desc-icon {
          width: auto;
          height: 670px;
        }
      }
      .text {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 43px;
        padding: 0px 38px;
        text-indent: 48px;
        word-break: break-all;
      }
    }
  }
}
</style>
